import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import { RawTask } from './f23b35d0eb9660c84023b202a90e52fd6f0a2a61aa3cdb0259c2096e0386af99.cfe-internal.js';

var TaskFactory = /*#__PURE__*/function () {
  function TaskFactory(onError) {
    _classCallCheck(this, TaskFactory);
    this.onError = onError;
    this.freeTasks = [];
  }
  _createClass(TaskFactory, [{
    key: "create",
    value: function create(task) {
      var tasks = this.freeTasks;
      var t1 = tasks.length ? tasks.pop() : new RawTask(this.onError, function (t) {
        return tasks[tasks.length] = t;
      });
      t1.task = task;
      return t1;
    }
  }]);
  return TaskFactory;
}();

export { TaskFactory };
